import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useRef, useState, useCallback } from 'react';
export function useSwipeToDismiss(_ref) {
  var onDismiss = _ref.onDismiss,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? 'bottom' : _ref$direction,
    _ref$dismissThreshold = _ref.dismissThreshold,
    dismissThreshold = _ref$dismissThreshold === void 0 ? 0.25 : _ref$dismissThreshold,
    _ref$velocityThreshol = _ref.velocityThreshold,
    velocityThreshold = _ref$velocityThreshol === void 0 ? 0.05 : _ref$velocityThreshol,
    transformElementRef = _ref.transformElementRef,
    _ref$enabled = _ref.enabled,
    enabled = _ref$enabled === void 0 ? true : _ref$enabled;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDragging = _useState2[0],
    setDragging = _useState2[1];
  var _useState3 = useState(['0', '0', '0']),
    _useState4 = _slicedToArray(_useState3, 2),
    transform3DValues = _useState4[0],
    setTransform3DValues = _useState4[1];
  var pointerStart = useRef(0);
  var dragStartTime = useRef(null);
  var elementRef = useRef(null);
  var isVertical = direction === 'top' || direction === 'bottom';
  var directionMultiplier = direction === 'bottom' || direction === 'right' ? 1 : -1;
  var getElementHeight = useCallback(function () {
    var element = transformElementRef.current || elementRef.current;
    if (!element) {
      return 0;
    }
    return isVertical ? element.getBoundingClientRect().height : element.getBoundingClientRect().width;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVertical]);
  var onPress = useCallback(function (event) {
    if (!enabled) {
      return;
    }
    var element = event.currentTarget;
    elementRef.current = element;
    setDragging(true);
    dragStartTime.current = new Date();
    pointerStart.current = isVertical ? event.pageY : event.pageX;

    // Обеспечиваем правильный захват указателя
    element.setPointerCapture(event.pointerId);
  }, [enabled, isVertical]);
  var onDrag = useCallback(function (event) {
    if (!enabled || !isDragging || !elementRef.current) {
      return;
    }
    var currentPosition = isVertical ? event.pageY : event.pageX;
    var delta = (pointerStart.current - currentPosition) * directionMultiplier;

    // Разрешаем перетаскивание только в направлении закрытия
    if (delta < 0) {
      if (isVertical) {
        setTransform3DValues(['0', "".concat(-delta * directionMultiplier, "px"), '0']);
      } else {
        setTransform3DValues(["".concat(-delta * directionMultiplier, "px"), '0', '0']);
      }
    }
  }, [enabled, isDragging, isVertical, directionMultiplier]);
  var onRelease = useCallback(function (event) {
    if (!enabled || !isDragging || !elementRef.current || !dragStartTime.current) {
      return;
    }
    var endTime = new Date();
    var currentPosition = isVertical ? event.pageY : event.pageX;
    var timeTaken = endTime.getTime() - dragStartTime.current.getTime();
    var distMoved = pointerStart.current - currentPosition;
    var velocity = Math.abs(distMoved) / timeTaken;
    var elementSize = getElementHeight();
    var dismissDistance = elementSize * dismissThreshold;
    var lastTransform = transform3DValues;
    var moveDirection = distMoved > 0 ? 1 : -1;
    // Сбрасываем состояние
    setTransform3DValues(['0', '0', '0']);
    setDragging(false);

    // Определяем, нужно ли закрыть
    if ((velocity > velocityThreshold || Math.abs(distMoved) >= dismissDistance) && moveDirection === -1) {
      onDismiss === null || onDismiss === void 0 || onDismiss(lastTransform);
    }
    dragStartTime.current = null;
  }, [enabled, isDragging, transform3DValues, isVertical, getElementHeight, dismissThreshold, velocityThreshold, onDismiss]);
  return {
    transform3DValues: transform3DValues,
    isDragging: isDragging,
    onPointerDown: onPress,
    onPointerMove: onDrag,
    onPointerUp: onRelease,
    onPointerCancel: onRelease
  };
}